var EgdsSizingLengths = [
    '0x',
    '0x__half',
    '0x__quarter',
    '1x',
    '1x__half',
    '2x',
    '3x',
    '3x__half',
    '4x',
    '4x__half',
    '5x',
    '6x',
    '7x',
    '8x',
    '9x',
    '10x',
    '11x',
    '12x',
    '13x',
    '14x',
    '15x',
    '16x',
    '17x',
    '18x',
    '24x',
    '30x',
    '37x',
    '38x',
    '40x',
    '48x',
    '70x',
    '72x',
    '76x',
    '88x',
    '96x',
    '104x',
    '112x',
    '120x',
    '180x',
    '312x',
    '500x'
];
var UitkLayoutFlexDirectionMap = [
    ['row', 'flex-direction-row'],
    ['row-reverse', 'flex-direction-row-reverse'],
    ['column', 'flex-direction-column'],
    ['column-reverse', 'flex-direction-column-reverse']
];
var UitkLayoutFlexDirections = new Map(UitkLayoutFlexDirectionMap);
var UitkLayoutFlexWrapMap = [
    ['nowrap', 'flex-wrap-nowrap'],
    ['wrap', 'flex-wrap-wrap'],
    ['wrap-reverse', 'flex-wrap-wrap-reverse']
];
var UitkLayoutFlexWraps = new Map(UitkLayoutFlexWrapMap);
var UitkLayoutFlexAlignContentMap = [
    ['center', 'align-content-center'],
    ['end', 'align-content-flex-end'],
    ['start', 'align-content-flex-start'],
    ['space-around', 'align-content-space-around'],
    ['space-between', 'align-content-space-between']
];
var UitkLayoutFlexAlignContents = new Map(UitkLayoutFlexAlignContentMap);
var UitkLayoutFlexJustifyContentMap = [
    ['center', 'justify-content-center'],
    ['end', 'justify-content-flex-end'],
    ['start', 'justify-content-flex-start'],
    ['space-around', 'justify-content-space-around'],
    ['space-between', 'justify-content-space-between']
];
var UitkLayoutFlexJustifyContents = new Map(UitkLayoutFlexJustifyContentMap);
var UitkLayoutFlexAlignItemsMap = [
    ['center', 'align-items-center'],
    ['end', 'align-items-flex-end'],
    ['start', 'align-items-flex-start'],
    ['stretch', 'align-items-stretch']
];
var UitkLayoutFlexAlignItems = new Map(UitkLayoutFlexAlignItemsMap);
var UitkLayoutFlexItemGrows = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var UitkLayoutFlexItemShrinks = [0, 1];
var UitkLayoutFlexItemAlignSelfMap = [
    ['center', 'align-self-center'],
    ['end', 'align-self-flex-end'],
    ['start', 'align-self-flex-start'],
    ['stretch', 'align-self-stretch']
];
var UitkLayoutFlexItemAlignSelfs = new Map(UitkLayoutFlexItemAlignSelfMap);
var UitkLayoutFlexBlockSizeMap = [['full_size', 'block-size-full-size']];
var UitkLayoutFlexBlockSizes = new Map(UitkLayoutFlexBlockSizeMap);

export { EgdsSizingLengths, UitkLayoutFlexAlignContents, UitkLayoutFlexAlignItems, UitkLayoutFlexBlockSizes, UitkLayoutFlexDirections, UitkLayoutFlexItemAlignSelfs, UitkLayoutFlexItemGrows, UitkLayoutFlexItemShrinks, UitkLayoutFlexJustifyContents, UitkLayoutFlexWraps };
